module.exports = __webpack_public_path__ + "static/media/engine-large.95376d19.jpg";